import { Injectable } from "@angular/core";
import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/reducers';


@Injectable()
export class NavigatorEffects {

	constructor( private actions$: Actions, private store: Store<AppState> ) {
	}

}